<template>
  <div class="slide-become-premium" style="padding-bottom: 120px">
    <div v-if="new Date() < new Date('2026-08-01')" class="mb-4 text-center"> <!-- Banner promo Summer 2026 -->
      <img src="https://bubbleplan.net/assets/img/special/banner-summer26.png" class="d-none d-md-inline" alt="Offre promo Summer 2026" width="1470" height="156" style="max-width: 100%; height: auto">
      <img src="https://bubbleplan.net/assets/img/special/banner-summer26-sm.png" class="d-md-none" alt="Offre promo Summer 2026" width="690" height="275" style="max-width: 100%; height: auto">
    </div>
    <div class="d-flex gap-8 align-end mb-8 position-relative">
      <div>
        <div style="font-size: 28px">
          <b v-if="isExpired && ! isTrial" class="text-errorred">{{ $t('PREMIUM.SUSPENDED.ACCOUNT_SUSPENDED') }}</b>
          <b v-else>{{ $t('PREMIUM.SUBSCRIPTION.PREMIUM_SUBSCRIPTION') }}</b>
        </div>

        <div class="line-height-comfortable" style="min-height: 65px">
          <template v-if="isExpired && isTrial">
            <b><span v-html="$t('PREMIUM.SUSPENDED.TRIAL_EXPIRED_SINCE_HTML')"></span><span class="nobr">{{ $filters.moment(premiumExpireDate, 'date') }}</span>.</b>
            {{ $t('PREMIUM.SUSPENDED.TO_KEEP_WORKING') }} {{ $t('PREMIUM.SUSPENDED.SUBSCRIBE_PREMIUM') }}
          </template>
          <template v-else-if="isExpired && ! isTrial">
            <b><span v-html="$t('PREMIUM.SUSPENDED.ACCOUNT_EXPIRED_SINCE_HTML')"></span><span class="nobr">{{ $filters.moment(premiumExpireDate, 'date') }}</span>.</b>
            {{ $t('PREMIUM.SUSPENDED.TO_KEEP_WORKING') }} {{ $t('PREMIUM.SUSPENDED.RENEW_PREMIUM') }}
          </template>
          <template v-else-if="isTrial">
            <b class="nobr"><span v-html="$t('PREMIUM.ACCOUNT_IS_TRIAL')"></span> {{ $filters.moment(premiumExpireDate, 'date') }}</b>.
            {{ $t('PREMIUM.TO_CONTINUE_PREMIUM') }}
          </template>
          <template v-else>
            <b class="nobr"><span v-html="$t('PREMIUM.ACCOUNT_IS_FREE')"></span></b>.
            {{ $t('PREMIUM.BECOME_PREMIUM') }}
          </template>
        </div>
      </div>

      <!-- PACKAGES TOGGLE -->
      <btn-toggle-filter v-model="planPeriod" mandatory style="flex: 0 0 auto">
        <v-btn value="yearly" class="px-2 py-1 h-100">
          <span class="text-uppercase">{{ $t('PREMIUM.SUBSCRIPTION.ANNUAL') }}</span><span class="ml-1">{{ $t('PREMIUM.SUBSCRIPTION.PRICING_OFFER') }}</span>
        </v-btn>
        <v-btn value="monthly" class="text-uppercase px-4 py-1 h-100">
          {{ $t('PREMIUM.SUBSCRIPTION.MONTHLY') }}
        </v-btn>
      </btn-toggle-filter>

      <img src="./img/french-team.png" alt="" style="position: absolute; right: 48px; top: -24px">
    </div>

    <!-- PACKAGES -->
    <div class="d-flex flex-wrap flex-md-nowrap gap-8 text-center">
      <!-- TEAM -->
      <div class="d-flex flex-column tada-hover rounded overflow-hidden" :class="darkMode ? 'bg-surface' : 'bg-background'"
           :style="{ '--pack-color': colors.team }" style="flex: 1 1 34%; max-width: 350px">
        <!-- Team header -->
        <div class="px-6 py-4 text-white text-left" style="background-color: var(--pack-color)">
          <div class="text-h5">{{ $t('PREMIUM.SUBSCRIPTION.TEAM') }}</div>
          <div class="mt-2 small line-height-comfortable">{{ $t('PREMIUM.SUBSCRIPTION.TEAM_DESCRIPTION') }}</div>
        </div>
        <div class="pricing-1-content pb-5" style="border-color: var(--pack-color)">
          <div class="mt-5 mb-2 d-flex align-center justify-space-evenly">
            <div style="font-size: 24px; color: var(--pack-color)">{{ planPeriod == 'yearly' ? '12,90€' : '15,50€' }}</div>
            <div class="text-left small line-height-comfortable">
              {{ $t('PREMIUM.SUBSCRIPTION.PER_USER_PER_MONTH') }}
              <br>{{ planPeriod == 'yearly' ? $t('PREMIUM.SUBSCRIPTION.BILLED_ANNUALLY') : $t('PREMIUM.SUBSCRIPTION.NO_TIME_COMMITMENT') }}
            </div>
          </div>
          <form @submit.prevent="sendTeamDataCheckout()">
            <!-- Select Users -->
            <v-select v-model="quantityUsersTeam" :items="usersList" density="compact" class="mb-2 pa-3"></v-select>
            <!-- Btn Choose -->
            <v-btn type="submit" :color="colors.team" size="large" rounded class="tada-btn text-white" style="min-width: 50%">
              {{ $t('PREMIUM.SUBSCRIPTION.CHOOSE_PLAN') }} {{ $t('PREMIUM.SUBSCRIPTION.TEAM') }}
            </v-btn>
          </form>
          <p class="premium-features px-4 mt-6" v-html="$t('PREMIUM.SUBSCRIPTION.TEAM_PACKAGE_INCLUDED')"></p>
        </div>
      </div>
      <!-- BUSINESS -->
      <div class="d-flex flex-column tada-hover rounded overflow-hidden elevation-4" :class="darkMode ? 'bg-surface' : 'bg-background'"
           :style="{ '--pack-color': colors.business }" style="flex: 1 1 34%; max-width: 350px">
        <!-- Business header -->
        <div class="px-6 py-4 text-white text-left position-relative" style="background-color: var(--pack-color)">
          <div class="text-h5">{{ $t('PREMIUM.SUBSCRIPTION.BUSINESS') }}</div>
          <div class="mt-2 small line-height-comfortable">{{ $t('PREMIUM.SUBSCRIPTION.BUSINESS_DESCRIPTION') }}</div>
          <div class="text-black small flex-center-center py-1 px-2 rounded-bs rounded-te"
               style="position: absolute; top: 0px; right: 0; background: linear-gradient(270.17deg, #EBAB00 0%, #FFEF42 100%);">
            <i class="fas fa-heart mr-1"></i>
            <i>{{ $t("PREMIUM.SUBSCRIPTION.RECOMMENDED") }}</i>
          </div>
        </div>
        <div class="pricing-1-content pb-5" style="border-color: var(--pack-color)">
          <div class="mt-5 mb-2 d-flex align-center justify-space-evenly">
            <div style="font-size: 24px; color: var(--pack-color)">{{ planPeriod == 'yearly' ? '24,90€' : '29,90€' }}</div>
            <div class="text-left small line-height-comfortable">
              {{ $t('PREMIUM.SUBSCRIPTION.PER_USER_PER_MONTH') }}
              <br>{{ planPeriod == 'yearly' ? $t('PREMIUM.SUBSCRIPTION.BILLED_ANNUALLY') : $t('PREMIUM.SUBSCRIPTION.NO_TIME_COMMITMENT') }}
            </div>
          </div>
          <form @submit.prevent="sendBusinessDataCheckout()">
            <!-- Select Users -->
            <v-select v-model="quantityUsersBusiness" :items="usersList" density="compact" class="mb-2 pa-3"></v-select>
            <!-- Btn Choose -->
            <v-btn type="submit" :color="colors.business" size="large" rounded class="tada-btn text-white" style="min-width: 50%">
              {{ $t('PREMIUM.SUBSCRIPTION.CHOOSE_PLAN') }} {{ $t('PREMIUM.SUBSCRIPTION.BUSINESS') }}
            </v-btn>
          </form>
          <p class="premium-features px-4 mt-6" v-html="$t('PREMIUM.SUBSCRIPTION.BUSINESS_PACKAGE_INCLUDED')"></p>
        </div>
      </div>
      <!-- ENTERPRISE -->
      <div class="d-flex flex-column rounded overflow-hidden" :class="darkMode ? 'bg-surface' : 'bg-background'"
           :style="{ '--pack-color': colors.enterprise }" style="flex: 1 1 34%; max-width: 350px">
        <!-- Business header -->
        <div class="px-6 py-4 text-white text-left" style="background-color: var(--pack-color)">
          <div class="text-h5">{{ $t('PREMIUM.SUBSCRIPTION.ENTERPRISE') }}</div>
          <div class="mt-2 small line-height-comfortable">{{ $t('PREMIUM.SUBSCRIPTION.ENTERPRISE_DESCRIPTION') }}</div>
        </div>
        <div class="pricing-1-content pb-5" style="border-color: var(--pack-color)">
          <div class="flex-center-center gap-4 mt-4 mb-5">
            <i class="far fa-buildings" style="font-size: 40px; color: var(--pack-color)"></i>
            <span class="pre text-left small line-height-comfortable">{{ $t('PREMIUM.SUBSCRIPTION.ON_DEMAND') }}</span>
          </div>
          <div class="mb-4 pa-3">{{ $t('PREMIUM.SUBSCRIPTION.MINIMUM_USERS') }}</div>
          <form @submit.prevent="sendBusinessDataCheckout()">
            <!-- Btn Choose -->
            <v-btn type="submit" :color="colors.enterprise" size="large" rounded class="text-white" style="min-width: 50%">
              {{ $t('PREMIUM.SUBSCRIPTION.CONTACT_US') }}
            </v-btn>
          </form>
          <p class="premium-features px-4 mt-6" v-html="$t('PREMIUM.SUBSCRIPTION.ENTERPRISE_PACKAGE_INCLUDED')"></p>
        </div>
      </div>
    </div>

    <div class="d-flex flex-wrap flex-md-nowrap gap-4 my-12">
      <!-- Free Offer -->
      <div v-if="! isFree" class="rounded pa-4 d-flex align-center gap-6" style="max-width: 600px; border: 2px solid #DCE4F2;">
        <div><img src="./img/free-pack.png" alt="free package" style="width: 170px"></div>
        <div>
          <b>{{ $t('PREMIUM.SUSPENDED.FREE_OFFER') }}</b>
          <div class="my-3 line-height-comfortable" v-html="$t('PREMIUM.SUSPENDED.FREE_DESC')"></div>
          <div class="d-flex flex-wrap justify-center" style="gap: 8px">
            <div>
              <v-btn :loading="resetingFree.inprogress" rounded variant="outlined" @click="resetFreeAccount()">{{ $t('PREMIUM.SUSPENDED.ACTIVATE_FREE') }}</v-btn>
              <p v-show="resetingFree.error">{{ resetingFree.error }}</p>
            </div>
            <v-btn v-if="! isExpired" rounded variant="outlined" @click="$emit('close')">{{ $t('PREMIUM.SUBSCRIPTION.KEEP_TRIAL') }}</v-btn>
          </div>
        </div>
      </div>
      <!-- Compare -->
      <div class="rounded d-flex flex-column" style="max-width: 240px; flex-basis: 240px; border: 2px solid #DCE4F2;">
        <div class="flex-grow-1 align-content-center pa-2"><img src="./img/compare-packages.png" alt="compare packages" class="w-100"></div>
        <div class="mt-auto px-2 pb-4 text-center">
          <v-btn rounded variant="outlined" href="https://bubbleplan.net/comparatif-gratuit-premium#pricing-details" target="_blank" rel="noopener">
            {{ $t('PREMIUM.SUBSCRIPTION.COMPARE_PACKAGES') }}
          </v-btn>
        </div>
      </div>
      <!-- Contact Us -->
      <div class="rounded d-flex flex-column" style="max-width: 240px; flex-basis: 240px; border: 2px solid #DCE4F2;">
        <img src="./img/book-demo.png" alt="book a demo" class="w-100">
        <div class="mt-auto px-4">{{ $t('PREMIUM.SUBSCRIPTION.HAVE_QUESTIONS') }}</div>
        <div class="mt-auto px-2 pb-4 text-center">
          <v-btn rounded variant="outlined" href="https://crm.zoho.eu/bookings/DemoPitchEssaiPremium?rid=5e289f9939a784d580464facd7043ae3a141859e4a19c46462cacdeda7d7ea35e5a6bda45a670cc2029996da25be1d04giddd31d1e631a028015aecf4a5a63b99b9903a06edccbe9c1436b8f14add76d621" target="_blank" rel="noopener">
            {{ $t('PREMIUM.SUBSCRIPTION.BOOK_DEMO') }}
          </v-btn>
        </div>
      </div>
    </div>

    <!-- BOTTOM BANNER -->
    <div class="bg-background py-6 mx-lg-n8 d-flex gap-4 align-center justify-space-between" style="position: fixed; bottom: 0; width: calc(1016px + 16*4px); max-width: 100%">
      <div class="font-weight-bold text-center align-self-start position-relative line-height-comfortable pt-2 pb-4" style="width: 220px">
        {{ $t('PREMIUM.SUBSCRIPTION.JOIN_HAPPY_CUSTOMERS') }}
        <div class="d-flex" style="position: absolute; bottom: 0; left: 0; right: 0;">
          <div class="flex-grow-1" style="height: 8px; background-color: #000091;"></div>
          <div class="flex-grow-1" style="height: 8px; background-color: white;"></div>
          <div class="flex-grow-1" style="height: 8px; background-color: #E1000F;"></div>
        </div>
      </div>
      <img src="./img/notation.png" style="height: 70px">
      <img src="./img/sncf.png" style="height: 50px">
      <img src="./img/departement-vienne.png" style="height: 50px">
      <img src="./img/bioviva.png" style="height: 50px">
      <img src="./img/maif.png" style="height: 50px">
      <img src="./img/metro.png" style="height: 50px">
    </div>
  </div>
</template>

<style lang='scss'>
  @use 'animate.css/source/attention_seekers/tada.css';

  .tada-hover:hover {
    .tada-btn {
      animation-name: tada;
      animation-duration: 1s;
      animation-fill-mode: both;
      animation-iteration-count: 1;
    }
  }

  .slide-become-premium {
    .premium-features {
      text-align: left;

      ul {
        padding-left: 4px;
        list-style: none;

        li {
          position: relative;
          padding-left: 20px;

          &::before {
            content: '✓';
            font-weight: 800;
            color: var(--pack-color);
            position: absolute;
            left: 0;
          }
        }
      }
    }

    .pricing-1-content {
      border-width: 1px;
      border-style: solid;
      border-top: none;
      border-radius: 0 0 12px 12px;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
    }
  }
</style>

<script>
  import darkModeMixin from '@/components/Manage/ManageProfile/darkModeMixin';
  import useUsersStore from '@/stores/users';
  import useUsersAccessRightStore from '@/stores/users/accessRight';

  export default {
    emits: ['send-data-checkout', 'close'],
    mixins: [darkModeMixin],
    data() {
      const usersStore = useUsersStore();
      return {
        planPeriod: 'yearly',
        quantityUsersTeam: usersStore.user.company?.users?.length || 10,
        quantityUsersBusiness: usersStore.user.company?.users?.length || 10,
        usersList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 20, 30, 40, 50].map((nbUsers) => {
          return { value: nbUsers, title: `${nbUsers} ${this.$t('PREMIUM.SUBSCRIPTION.USERS', nbUsers)}` };
        }),
        colors: { team: '#278bff', business: '#3cd458', enterprise: '#606060' },
        resetingFree: { inprogress: false, error: "" },
        usersStore,
        usersAccessRightStore: useUsersAccessRightStore(),
      };
    },
    computed: {
      user() { return this.usersStore.user; },
      isFree() { return ! this.user.company?.premiumExpireDate; },
      premiumExpireDate() {
        return this.user.company.premiumExpireDate;
      },
      isTrial() { return this.usersAccessRightStore.isTrial; },
      isExpired() { return this.usersStore.user.company?.isPremiumExpired; },
    },
    methods: {
      sendTeamDataCheckout() {
        const plan = this.planPeriod == 'yearly' ? 'team12m' : 'team';
        this.$emit('send-data-checkout', { plan, users: this.quantityUsersTeam });
      },
      sendBusinessDataCheckout() {
        const plan = this.planPeriod == 'yearly' ? 'business12m' : 'business';
        this.$emit('send-data-checkout', { plan, users: this.quantityUsersBusiness });
      },
      resetFreeAccount() {
        if (! window.confirm(this.$t('PREMIUM.SUSPENDED.ACTIVATE_FREE_CONFIRM'))) return;
        this.resetingFree = { inprogress: true, error: "" };
        window.apiSrv.call(`companies/${this.usersStore.user.company_id}/resetfree`, 'index').then(() => {
          window.location.href = ""; // reload
        }).catch((message) => {
          this.resetingFree = { inprogress: false, error: `Error : ${message}` };
        });
      },
    },
  };
</script>
